import { render, staticRenderFns } from "./AttributeDisplay.vue?vue&type=template&id=838a3076&scoped=true"
import script from "./AttributeDisplay.vue?vue&type=script&lang=js"
export * from "./AttributeDisplay.vue?vue&type=script&lang=js"
import style0 from "./AttributeDisplay.vue?vue&type=style&index=0&id=838a3076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838a3076",
  null
  
)

export default component.exports